var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInkDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75C8.27344 21.75 5.25 18.7266 5.25 15C5.25 14.3906 5.48906 13.4297 6.04688 12.1359C6.58594 10.8891 7.34062 9.52031 8.17969 8.16562C9.53906 5.97187 11.0391 3.9375 12 2.68125C12.9609 3.93281 14.4656 5.97187 15.8203 8.16562C16.6594 9.52031 17.4141 10.8844 17.9531 12.1359C18.5109 13.4297 18.75 14.3953 18.75 15C18.75 18.7266 15.7266 21.75 12 21.75ZM3 15C3 19.9688 7.03125 24 12 24C16.9688 24 21 19.9688 21 15C21 10.725 14.8969 2.70469 13.1906 0.548437C12.9094 0.196875 12.4922 0 12.0422 0H11.9578C11.5078 0 11.0906 0.196875 10.8094 0.548437C9.10313 2.70469 3 10.725 3 15ZM9.75 14.625C9.75 14.0016 9.24844 13.5 8.625 13.5C8.00156 13.5 7.5 14.0016 7.5 14.625C7.5 17.3156 9.68437 19.5 12.375 19.5C12.9984 19.5 13.5 18.9984 13.5 18.375C13.5 17.7516 12.9984 17.25 12.375 17.25C10.9266 17.25 9.75 16.0734 9.75 14.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkDrop);
export default __webpack_public_path__ + "static/media/inkDrop.848572202b70a6053f0212d9ef57bb55.svg";
export { ForwardRef as ReactComponent };